export default __webpack_public_path__ + "static/media/halls-3.948ddf75.webp";